<template>
  <div></div>
</template>

<script>
import { isEquipment } from '@/utils/browser'
import { fetchEvn, getQueryString } from '@/utils/utils'
import moment from 'moment'
export default {
  name: 'shortChain',
  data() {
      return {
          path: '',
          query: '',
          keyName: ''
      }
  },
  mounted() {
      this.init()
    //   console.log(moment(1722133732 * 1000).format('YYYY-MM-DD HH:mm:ss'), '过期时间')
  },
  methods: {
      addPrex(path, prex = 'merchent_program') {
        // 给商户端链接增加前缀，以区分C端小程序
        return `${prex}_${path}`
      },
      init(){
          this.path = getQueryString("path") || '';
          this.query = getQueryString("query") || '';
          this.keyName = this.addPrex(this.path)
          if (isEquipment().isPC) {
              this.$toast({
                  styles: {
                      maskColor: "rgba(0,0,0,0)",
                      background: "rgba(0,0,0,0.4)",
                      messageColor: "#fff"
                  },
                  content: '请使用移动端打开链接！',
                  duration: 2000
              })
              return
          }
          this.$ebLoading.show();
          this.handleTime()
      },
      handleTime(){
          let keyName = this.keyName
          let localData = localStorage.getItem(keyName) || '{}'
          let data = JSON.parse(localData) || {}
          try {
              if (Object.keys(data).length > 0) {
                  let { url , t } = data
                  if (new Date(t) < new Date() || !url) {
                      this.getLink()
                  } else {
                      this.$ebLoading.hide();
                      window.location.href = url
                  }
              } else {
                  this.getLink()
              }
          } catch (error) {
              this.getLink()
          }
      },
      getLink() {
          let { path = '', query = '', keyName = '' } = this
          let jumpWxaReqDTO = {
            path,
            query
          }
          if(['qa', 'pre'].includes(fetchEvn())) {
            jumpWxaReqDTO.envVersion = 'develop'
          }
          let params = {
            jumpWxaReqDTO
          }
        this.$fetch({ url: "/ehs/tools/merchant/general/support/url-link", method: "post" }, params).then(res => {
              if (res.success) {
                  this.$ebLoading.hide();
                  let urlLink = res.model
                  let expireTime = moment().add(29, 'd').format('YYYY-MM-DD HH:mm:ss') // 29天生成一次
                  if(urlLink) {
                    const data = { url: urlLink, t: expireTime }
                    localStorage.setItem(keyName, JSON.stringify(data))
                    window.location.href = urlLink
                  } else {
                    localStorage.removeItem(keyName)
                    this.$toast({
                        styles: {
                            maskColor: "rgba(0,0,0,0)",
                            background: "rgba(0,0,0,0.4)",
                            messageColor: "#fff"
                        },
                        content: res.errorMessage,
                        duration: 2000
                    })
                }
                  
              } else {
                  this.$toast({
                      styles: {
                          maskColor: "rgba(0,0,0,0)",
                          background: "rgba(0,0,0,0.4)",
                          messageColor: "#fff"
                      },
                      content: res.errorMessage,
                      duration: 2000
                  })
              }
          }).finally(() => {
              this.$ebLoading.hide();
          })
      }
  }
}
</script>